import { createFileRoute } from "@tanstack/react-router";
import {
  Activity,
  Building2,
  Cpu,
  Database,
  FileKey,
  Monitor,
  Settings,
  PackageOpen,
  Trash,
  PieChart,
  Link as LinkIcon,
  ScrollText,
  Sparkles,
  BookOpen,
} from "lucide-react";
import { SecondaryNav } from "@client/components/secondary-nav";

export const Route = createFileRoute("/_app/settings")({
  component: SettingsLayout,
});

// 系统设置仅超级管理员可访问（由侧栏 requireSuperAdmin 门控），不走 RBAC 权限
const settingsItems = [
  { title: "团队管理", to: "/settings/tenants" as const, icon: Building2 },
  { title: "AI 模型", to: "/settings/ai-models" as const, icon: Sparkles },
  { title: "解析引擎", to: "/settings/parser" as const, icon: Cpu },
  {
    title: "任务中心",
    to: "/settings/job-manager" as const,
    icon: Activity,
  },
  {
    title: "限额管理",
    to: "/settings/quota-management" as const,
    icon: PieChart,
  },
  { title: "行业包管理", to: "/settings/industry-packs" as const, icon: PackageOpen },
  { title: "存储清理", to: "/settings/storage-cleanup" as const, icon: Trash },
  { title: "审计日志", to: "/settings/audit-logs" as const, icon: ScrollText },
  { title: "数据连接", to: "/settings/data-sources" as const, icon: LinkIcon },
  { title: "系统状态", to: "/settings/system-status" as const, icon: Monitor },
  { title: "系统配置", to: "/settings/system" as const, icon: Settings },
  { title: "注册管理", to: "/settings/license" as const, icon: FileKey },
  { title: "数据库", to: "/settings/database" as const, icon: Database },
  { title: "帮助文档", to: "/settings/help-docs" as const, icon: BookOpen },
];

function SettingsLayout() {
  return <SecondaryNav title="系统设置" items={settingsItems} />;
}
